import React, { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useTranslation } from 'react-i18next'

interface Keyword {
  type: string
  word: string
  value: string
  checked: boolean
  displayed: boolean
}

interface Props {
  modalName: string
  keywordList: Keyword[]
  addKeyword: (e: string) => void
}

const KeywordChipList: FC<Props> = (props) => {
  const {
    modalName,
    keywordList,
    addKeyword,
  } = props

  const { t } = useTranslation()

  const NO_TRANS_LIST = ["チーム", "ユーザー", "アプリ"]

  return (
    <>
      <div className="title">
        <FontAwesomeIcon icon={['fas', 'search']} />
        &nbsp;
        {modalName}
      </div>
      {
        keywordList.filter((value) => value.displayed).length ? (
          <>
            <div className={`chips ${NO_TRANS_LIST.includes(modalName) ? "no_trans" : ""}`}>
              {
                keywordList.filter((value) => value.displayed).map((value) => (
                  value.checked ? (
                    <button type="button" key={value.value} className="checked">
                      {value.word}
                    </button>
                  ) : (
                    <button
                      type="button"
                      key={value.value}
                      className="rank_1"
                      onClick={() => addKeyword(value.value)}
                    >
                      {value.word}
                    </button>
                  )
                ))
              }
            </div>
          </>
        ) : (
          <>
            <div className="no_data">
              {t('search.index.no_data')}
            </div>
          </>
        )
      }
    </>
  )
}

export default KeywordChipList
